export function batch<T extends any[]>(list: T, size: number): T[] {
  return list
    .reduce(
      (a, c, i) => {
        a[i % size]!.push(c);
        return a;
      },
      Array.from({ length: size }, () => []),
    )
    .filter((b) => b.length);
}

export function xprod(...arrays: any[][]): any[][] {
  return arrays.reduce<any[][]>(
    (acc, curr) => {
      const result: any[][] = [];
      for (const a of acc) {
        for (const b of curr) {
          result.push([...a, b]);
        }
      }
      return result;
    },
    [[]],
  );
}

export async function parallel<T, R>(
  arr: T[],
  callback: (el: T, idx: number) => Promise<R>,
) {
  const out = await Promise.all(arr.map((el, idx) => callback(el, idx)));
  return out;
}

export function swap<T>(arr: T[], i: number, j: number): T[] {
  const newArr = [...arr];
  const temp = newArr[i]!;
  newArr[i] = newArr[j]!;
  newArr[j] = temp;
  return newArr;
}
